export default {"src":"/_next/static/media/Channel-Finance.4f6f73ff.svg","height":29,"width":28};